import { createRouter, createWebHistory } from 'vue-router'
import { Route } from '@/types'; // must be imported since file contains an export statement
import store from '@/store';

// function loadLoginRoutes() {
//     const loginRoutes = require('/layouts/login/routes.ts');
//     return loginRoutes.keys().map(loginRoutes).map((m: any) => m.route);
// }

// Import all of the resource routes files
function loadRoutes() {
    const context = require.context('@/modules', true, /routes.ts$/i)
    return context.keys()
        .map(context) // import module
        .map((m: any) => m.route) // get `default` export from each resolved module
}

function loadLoginRoutes() {
    const context = require.context('@/layouts/login', true, /routes.ts$/i)
    return context.keys()
        .map(context) // import module
        .map((m: any) => m.route) // get `default` export from each resolved module
}

// Define the routes
const routes: Route[] = []
const resourceRoutes = loadRoutes();
const loginRoutes = loadLoginRoutes();

loginRoutes.forEach((loginRoute) => {
    loginRoute.forEach((route: Route) => {
        routes.push(route)
    })
});

resourceRoutes.forEach((moduleRoutes) => {
    moduleRoutes.forEach((route: Route) => {
        routes.push(route)
    })
});

// Create the router instance and pass the `routes` option
export const router = createRouter({
    history: createWebHistory('/online'), // use history mode
    routes, // short for `routes: routes`
})

router.beforeEach((to, from, next) => {
    //Set document title to title of route
    if (typeof(to.meta.name) === 'string'){
        document.title = to.meta.name + ' | Floodplain Consultants Inc.'
    }
    //Check if page requires user to be logged in
    if (to.meta.requiresAuth){
        //If user is logged in continue
        if (store?.state?.user?.loggedIn){
            next()
        }else{
            //If user is not logged in redirect to login page
            if (typeof(to.meta.name) === 'string'){
                document.title = 'Login' + ' | Floodplain Consultants Inc.'
            }
            next({ name: 'User Login'})
        }
    }else{
        if (store?.state?.user?.loggedIn){
            if (to.name == 'User Login'){
                next({ name: 'Dashboard'})
            }else{
                next()
            }
        }else{
            next()
        }
    }
})